<template xmlns:v-col="http://www.w3.org/1999/html">
  <v-container
    fluid
  >
    <!--- v-if="this.$store.getters.has_permission(['Status_r', 'Status_rw'])" --->
    <v-row
      v-if="$store.getters.inPrivateNet"
    >
      <v-col
        v-for="(station, index) in stations"
        :key="index"
        cols="12"
        xs="6"
        sm="6"
        md="4"
        lg="3"
        xl="3"

        :order="station.order"
        :order-sm="station.order_sm"
        :order-md="station.order_md"
        :order-lg="station.order_lg"
        :order-xl="station.order_xl"
      >
        <Station
          :station="station"
        >
        </Station>
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        xs="6"
        sm="6"
        md="4"
        lg="3"
        xl="3"
      >
        <v-alert
          type="warning"
        >
          Außerhalb des Feuerwehrnetzes steht diese Seite nur eingeschränkt zur Verfügung.
        </v-alert>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row
      v-if="!$store.getters.inPrivateNet"
    >
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="4"
        xl="3"
      >
        <Rufgruppe_beantragen></Rufgruppe_beantragen>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="4"
        xl="3"
      >
        <LockPermissions></LockPermissions>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Station from "../components/Tableau/Station";
import Rufgruppe_beantragen from "../components/widgets/Rufgruppe_beantragen.vue";
import LockPermissions from "../components/widgets/LockPermissions.vue";
export default {
  name: "StatusTableau",
  components: { LockPermissions, Rufgruppe_beantragen, Station },
  computed: {
    stations(){
      return this.$store.state.status_tableau.stations.filter(station => station.display_name.toLowerCase().includes(this.$store.state.general.global_search.toLowerCase()))
    },
  },
  methods: {
    ping(){
      let _that = this

      this.img = new Image();
      this.img.onload = _that.print("load")
      this.img.onerror = _that.print("error")

      this.start = new Date().getTime();
      this.img.src = "https://www.google.de"
      this.timer = setTimeout(function() { _that.print("timeout")}, 1500);
    },
    print(i){
      console.log("kek" + i)
    },
  },

  created() {
    this.$store.dispatch("update", { "context": "/stations" })
    this.$store.dispatch("update", { "context": "/kentix/alarmgroups/status" })
    //if(this.$store.state.status_tableau.stations_list == null){
    //  this.$store.dispatch("update", { "context": "/stations" })
    //}
  },
};
</script>

<style scoped>

</style>
